export default "__VITE_ASSET__BAdRI0RQ__"